module.exports = __webpack_public_path__ + "static/media/Pic7.046d1d85.png";